export const WINDOW_HEIGHT = window.innerHeight;
